import type { BoxProps } from '@chakra-ui/react';
import { Box, Button } from '@chakra-ui/react';
import { ProductAddToCartButton } from 'components/product/ProductAddToCartButton';
import { useShopifyProduct } from 'hooks/product/useShopifyProduct';
import Link from 'next/link';
import type { PromoCode } from 'types/cart/PromoCode';
import type { ProductComparison } from 'types/cms/blocks';

interface ProductCTAProps extends BoxProps {
  href: string;
  slug: string;
  promoCode?: PromoCode;
  ctaType: ProductComparison['ctaType'];
}

export function ProductCTA({
  href,
  slug,
  promoCode,
  ctaType,
  ...props
}: ProductCTAProps) {
  const { data: shopifyProduct } = useShopifyProduct(slug);
  const variantId = shopifyProduct?.variants[0]?.id;

  return (
    <Box {...props}>
      {ctaType === 'atc' && variantId ? (
        <ProductAddToCartButton
          w="100%"
          size="sm"
          merchandiseId={variantId}
          promoCodes={promoCode ? [promoCode] : []}
        />
      ) : (
        <Button as={Link} href={href} w="100%" size="sm">
          Shop now
        </Button>
      )}
    </Box>
  );
}
